import React from 'react';
export function TestimonialCarousel() {
  return <section className="py-32 md:py-48 bg-background relative overflow-hidden" data-id="element-143">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1px] h-16 bg-gold/30" data-id="element-144"></div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[1px] h-16 bg-gold/30" data-id="element-145"></div>

      <div className="container mx-auto px-4 md:px-8 max-w-4xl text-center" data-id="element-146">
        <span className="text-gold text-4xl md:text-6xl font-serif leading-none opacity-50 block mb-8" data-id="element-147">
          "
        </span>

        <blockquote className="text-2xl md:text-4xl lg:text-5xl font-serif italic text-foreground leading-snug mb-12" data-id="element-148">
          I kept waiting to look 'done.' I never did. I just looked like myself
          — but the version I remembered from ten years ago.
        </blockquote>

        <cite className="block text-sm font-sans uppercase tracking-[0.2em] text-sage not-italic" data-id="element-149">
          — Patient, San Ramon CA
        </cite>
      </div>
    </section>;
}